import { render, staticRenderFns } from "./testReports.vue?vue&type=template&id=1f067afe&scoped=true&"
import script from "./testReports.vue?vue&type=script&lang=js&"
export * from "./testReports.vue?vue&type=script&lang=js&"
import style0 from "./testReports.vue?vue&type=style&index=0&id=1f067afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f067afe",
  null
  
)

export default component.exports